import { $, findTarget } from '../utils/Utils';

const accordion = (() => {
  const triggerCN = '.js-accordionTrigger';
  const triggers = [...$(triggerCN)];
  const parent = 'js-accordionParent';
  const targetCN = 'js-accordionTarget';
  const countLimit = 250;
  const arrowCN = '-arrow';
  const activeCN = '-active';

  const compactTarget = ({ trigger, target, txt }) => {
    // trim text
    target.innerHTML = txt.slice(0, countLimit).concat('\u2026');
    // update arrow direction
    trigger.classList.remove(activeCN);
  };

  const expandTarget = ({ trigger, target, txt }) => {
    // trim text
    target.innerHTML = txt;
    // update arrow direction
    trigger.classList.add(activeCN);
  };

  const toggleTarget = ({ trigger, target, txt }) => {
    (trigger.classList.contains(activeCN)) ?
      compactTarget({ trigger, target, txt })
      : expandTarget({ trigger, target, txt });
  };

  const handleClick = (trigger) => {
    const target = findTarget({ element: trigger, parent, target: targetCN });
    const txt = target.dataset.text;

    // if text is no longer than 150, then we don't need the accordion
    if (txt.length > countLimit) {
      // add arrow
      trigger.classList.add(arrowCN);
      // close target
      compactTarget({ trigger, target, txt });

      // handleClick
      trigger.addEventListener('click', () => {
        toggleTarget({ trigger, target, txt });
      });
    }
  };

  const build = () => {
    triggers.forEach((trigger) => {
      handleClick(trigger);
    });
  };

  const init = () => {
    if (triggers.length > 0) {
      build();
    }
  };

  return {
    init,
  };
})();

export default accordion.init();



// WEBPACK FOOTER //
// ./components/accordion.js